import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

const SIZES = {
  sm: { box: 40, icon: 20 },
  md: { box: 44, icon: 20 },
  lg: { box: 52, icon: 24 },
};
const TONES = {
  brand: { bg: gr.color.brandSoft, fg: gr.color.brandDark },
  neutral: { bg: gr.color.bg, fg: gr.color.ink2 },
  ok: { bg: gr.color.okSoft, fg: gr.color.ok },
  late: { bg: gr.color.lateSoft, fg: gr.color.late },
  overdue: { bg: gr.color.overdueSoft, fg: gr.color.overdue },
};

// Decorative icon square used in list rows, cards and notices.
export default function GrIconTile({
  size = "md",
  tone = "brand",
  children,
  sx,
  ...rest
}) {
  const s = SIZES[size] || SIZES.md;
  const t = TONES[tone] || TONES.brand;
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        width: s.box,
        height: s.box,
        flex: "none",
        display: "grid",
        placeItems: "center",
        borderRadius: gr.radius.tile,
        background: t.bg,
        color: t.fg,
        "& svg": { width: s.icon, height: s.icon },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

GrIconTile.propTypes = {
  size: PropTypes.oneOf(Object.keys(SIZES)),
  tone: PropTypes.oneOf(Object.keys(TONES)),
  children: PropTypes.node,
  sx: PropTypes.object,
};
